import { render, staticRenderFns } from "./recyclerList.vue?vue&type=template&id=6ed669e8&scoped=true&"
import script from "./recyclerList.vue?vue&type=script&lang=js&"
export * from "./recyclerList.vue?vue&type=script&lang=js&"
import style0 from "./recyclerList.vue?vue&type=style&index=0&id=6ed669e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed669e8",
  null
  
)

export default component.exports